import { Col, Row, Select } from "antd";
import { getTraderSurface, updateTraderSurface } from "api/volSurfaceApi";
import { GlobalContext } from "contexts/GlobalContext";
import { VolSurfaceContext } from "contexts/VolSurfaceContext";
import { toast } from "helpers/generalHelper";
import { useContext, useEffect, useState } from "react";

function TraderSurfaces({ selectedFilters }) {
  const [surfaces, setSurfaces] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedSurface, setSelectedSurface] = useState(null);
  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);

  const {
    state: { volSurfaceFilterShortcuts, isShortcutsLoading },
  } = useContext(VolSurfaceContext);

  useEffect(() => {
    if (
      !selectedFilters?.company_id ||
      !selectedFilters?.product_id ||
      !volSurfaceFilterShortcuts
    )
      return;
    setIsLoading(true);
    getTraderSurface({
      company_id: selectedFilters?.company_id,
      product_contract_style_id: selectedFilters?.product_id,
    })
      .then((res) => {
        const data = res?.data;
        setSurfaces(data);
        setSelectedSurface(
          data?.find((surface) => surface.selected === true)?.value
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [selectedFilters?.company_id, selectedFilters?.product_id, volSurfaceFilterShortcuts]);

  function handleSelectChange(value) {
    setIsUpdating(true);
    setSelectedSurface(value);
    updateTraderSurface({
      company_id: selectedFilters?.company_id,
      product_contract_style_id: selectedFilters?.product_id,
      user_vol_surface_id: value,
    })
      .then((res) => {
        toast(res?.data?.message, "success");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsUpdating(false);
      });
  }

  return (
    <Col span={24}>
      <Row>
        <Col span={3}>Set Surface:</Col>
        <Col>
          <Select
            loading={ isLoading}
            placeholder="Select Surface"
            className={
              dark_Theme
                ? "content_dark select-dark ant-select-dark-disabled"
                : "content_light select-light ant-input-light-disabled"
            }
            popupClassName={dark_Theme ? "dropdown-dark" : ""}
            value={isShortcutsLoading ? null : selectedSurface || undefined}
            style={{ width: 195 }}
            disabled={isShortcutsLoading || isUpdating || isLoading}
            onChange={(e) => handleSelectChange(e)}
            allowClear={false}
            showSearch
            filterOption={(input, option) => {
              const inputSmallLetter = input.toLowerCase();
              const label = option.label.toLowerCase();
              return label.includes(inputSmallLetter);
            }}
            options={surfaces}
          />
        </Col>
      </Row>
    </Col>
  );
}

export default TraderSurfaces;
